const VIEW_OPTIONS = Object.freeze([
  { value: "flat", label: "Flat list" },
  { value: "grouped", label: "Grouped by vehicle" },
]);

export default function PartnerInventoryViewToggle({
  value = "flat",
  onChange,
  groupedAvailable = true,
}) {
  return (
    <div className="partner-inventory-view-toggle" role="tablist" aria-label="Inventory view">
      {VIEW_OPTIONS.map((option) => {
        const selected = value === option.value;
        const disabled = option.value === "grouped" && !groupedAvailable;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={selected}
            aria-disabled={disabled}
            disabled={disabled}
            className={`partner-inventory-view-toggle__btn${selected ? " partner-inventory-view-toggle__btn--active" : ""}${disabled ? " partner-inventory-view-toggle__btn--disabled" : ""}`}
            onClick={() => {
              if (!disabled) onChange(option.value);
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
